(function() {
	/**
   * Renders Municipal Weather Map Page (new data structure; analogous to mountain)
   * @param {Object} props - Routing & page context
   * @returns {Promise<object>}
   */
	WebBaseAprovLV.renderMunicipalWeatherMapPage = function(props) {
		var params = {
			page: (props.context.params.page || ''),
			detail: (props.context.params.detail || '')
		};
		var model = {
			element: null,
			template: 'templates/southtyrol-weather-map.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: (props.context.Model || {}).Main || {},
				pageRaw: null,
				pageContent: null,
				navRaw: null,
				nav: null,
				venueMunicipalAreasData: null,
				skyConditions: null,
				municipalByDay: null
			}
		};
		var langparam = (WebBaseAprovLV.lang === 'lld' ? 'lld' : WebBaseAprovLV.lang);
		var fetchAsync = WebBaseAprovLV.Utils.fetchAsync({ dataType: 'json', cache: true });
		var fetchFresh = WebBaseAprovLV.Utils.fetchAsync({ dataType: 'json', cache: false });
		var timeLayoutIds = ['144000000', '144001440', '144002880', '144004320', '144005760', '144007200'];
		var cb = Date.now();
		var base = (WebBaseAprovLV.config.azureStorageUrl[WebBaseAprovLV.lang] || '');
		var altRoutes = WebBaseAprovLV.Utils.getAlternateSouthTyrolWeatherRouting(params.page);
		return $.when(
			WebBaseAprovLV.Utils.getKKData('?system.type=page&elements.url[in]=' + params.page + '&depth=1'),
			ejs.preloadTemplate(model.template),
			ejs.preloadTemplate('templates/breadcrumb.ejs.html?v=' + WebBaseAprovLV.version.template),
			ejs.preloadTemplate('templates/bottomnav.ejs.html?v=' + WebBaseAprovLV.version.template)
		)
		.then(function(pageXhr) {
			var pageRaw = Array.isArray(pageXhr) ? pageXhr[0] : (pageXhr || {});
			model.data.pageRaw = pageRaw;
			model.data.navRaw = {};
			var staticCalls = [
				fetchAsync(base + 'forecast-data/website/static-data/municipalities.json'),
				fetchAsync(base + 'forecast-data/website/static-data/sky_conditions.json')
			];
			var bulletinCalls = timeLayoutIds.map(function(id) {
				var url = base + 'forecast-data/website/southtyrol/' + langparam + '_' + id + '.json'
          + (base.indexOf('?') === -1 ? ('?cb=' + cb) : ('&cb=' + cb));
				var dfd = $.Deferred();
				fetchFresh(url)
				.done(function(resp) { dfd.resolve(Array.isArray(resp) ? resp[0] : resp); })
				.fail(function(_jqXHR, textStatus) {
					console.warn('Municipal forecast not found:', url, textStatus);
					dfd.resolve(null);
				});
				return dfd.promise();
			});
			return $.when.apply($, staticCalls.concat(bulletinCalls));
		})
		.then(function() {
			var args = Array.prototype.slice.call(arguments);
			var muniX = args[0];
			var skyX = args[1];
			var pubs = args.slice(2);
			var municipalitiesRaw = (Array.isArray(muniX) ? muniX[0] : (muniX || [])) || [];
			var skyRaw = (Array.isArray(skyX) ? skyX[0] : (skyX || [])) || [];
			var municipalities = WebBaseAprovLV.Utils.localizeMunicipalRecords(municipalitiesRaw, WebBaseAprovLV.lang);
			var municipalByDay = {};
			var latestUpdateISO = null;
			function parseNum(v) {
				if (v == null) {return null;}
				if (typeof v === 'number') {return (isFinite(v) ? v : null);}
				if (typeof v === 'string') {
					v = v.replace(',', '.').trim();
					var n = Number(v);
					return (isFinite(n) ? n : null);
				}
				return null;
			}
			(pubs || [])
			.map(function(r) { return Array.isArray(r) ? r[0] : r; })
			.filter(function(r) { return r && r.data && Array.isArray(r.data.bulletins); })
			.forEach(function(pub) {
				var lu = pub && pub.meta && (pub.meta.last_update || pub.meta.date);
				if (lu && (!latestUpdateISO || new Date(lu) > new Date(latestUpdateISO))) {
					latestUpdateISO = lu;
				}
				(pub.data.bulletins || []).forEach(function(b) {
					var iso = (b && b.period && b.period.start
						? WebBaseAprovLV.Utils.localIsoDayFromUTC(b.period.start)
						: '');
					if (!iso) {return;}
					if (!municipalByDay[iso]) {municipalByDay[iso] = { summary: null, municipalities: [], meta: {} };}
					if (!municipalByDay[iso].meta || !municipalByDay[iso].meta.last_update) {
						municipalByDay[iso].meta = { last_update: lu || null };
					}
					if (!municipalByDay[iso].summary) {
						var T = b.temperatures || b.temperature || {};
						var Tmin = T && T.min ? T.min : null;
						var Tmax = T && T.max ? T.max : null;
						municipalByDay[iso].summary = {
							id_time_layout: b.id_time_layout,
							title: b.title || '',
							conditions: b.conditions || '',
							weather: b.weather || '',
							temperatureText: b.temperature || '',
							reliability: b.reliability,
							skyKey: String(b.skyCondition || '').toUpperCase(),
							tminLow: parseNum(Tmin && Tmin.low),
							tminHigh: parseNum(Tmin && Tmin.high),
							tmaxLow: parseNum(Tmax && Tmax.low),
							tmaxHigh: parseNum(Tmax && Tmax.high)
						};
					}
					var metrics = Array.isArray(b.municipalityMetrics) ? b.municipalityMetrics : [];
					metrics.forEach(function(m) {
						if (!m || m.venueId == null) {return;}
						municipalByDay[iso].municipalities.push({
							venueId: String(m.venueId),
							sky_condition: m.sky_condition || null,
							temperature_minimum: m.temperature_minimum,
							temperature_maximum: m.temperature_maximum,
							rain_fall: m.rain_fall,
							rain_probability: m.rain_probability,
							sunshine_duration: m.sunshine_duration,
							wind_speed: m.wind_speed,
							wind_gust: m.wind_gust,
							wind_direction: m.wind_direction,
							snow_level: m.snow_level,
							fresh_snow: m.fresh_snow,
							freezing_level: m.freezing_level
						});
					});
				});
			});
			model.element = $('#content');
			model.data = $.extend(model.data, {
				pageContent: (WebBaseAprovLV.Utils.getKKViewModel(model.data.pageRaw)[0] || {}),
				nav: (WebBaseAprovLV.Utils.getKKViewModel(model.data.navRaw)[0] || {}),
				venueMunicipalAreasData: municipalities,
				skyConditions: skyRaw || [],
				latestUpdateISO: latestUpdateISO,
				municipalByDay: municipalByDay
			});
			return WebBaseAprovLV.Utils.transitionTo(model);
		})
		.then(function(ejsmodel) {
			ejsmodel.data.UILangSwitch = WebBaseAprovLV.Utils.tuneUILangSwitchers({
				page: {
					segment: {
						'de': altRoutes.de,
						'it': altRoutes.it,
						'lld': altRoutes.lld,
						'en': altRoutes.en
					}
				},
				detail: { id: '' }
			}, $('a.langchange'));
			return ejsmodel;
		})
		.promise();
	};
})();
